import { useEffect, useState } from "react";
import { platform } from "../platform";
import type { AuthError } from "../platform/PlatformAdapter";

interface VerifyEmailPageProps {
  token: string;
}

function goToSignIn() {
  const url = new URL(window.location.href);
  url.pathname = "/";
  url.search = "";
  window.location.href = url.toString();
}

export function VerifyEmailPage({ token }: VerifyEmailPageProps) {
  const [status, setStatus] = useState<"pending" | "success" | "error">("pending");
  const [error, setError] = useState<AuthError | null>(null);

  useEffect(() => {
    let cancelled = false;
    platform.verifyEmail(token).then((result) => {
      if (cancelled) return;
      if (result.ok) {
        setStatus("success");
      } else {
        setError(result.error);
        setStatus("error");
      }
    });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0, 0, 0, 0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="theme-panel" style={{ width: "min(90%, 380px)", padding: "2rem" }}>
        {status === "pending" && (
          <>
            <h2 style={{ margin: "0 0 1rem", fontSize: "1.3rem" }}>Verifying your email...</h2>
            <p style={{ opacity: 0.8, fontSize: "0.9rem", lineHeight: 1.5 }}>One moment.</p>
          </>
        )}
        {status === "success" && (
          <>
            <h2 style={{ margin: "0 0 1rem", fontSize: "1.3rem" }}>Email verified</h2>
            <p style={{ opacity: 0.8, fontSize: "0.9rem", lineHeight: 1.5 }}>
              Your email has been verified. You can now log in.
            </p>
            <button
              onClick={goToSignIn}
              className="theme-button"
              style={{ marginTop: "1rem", padding: "0.5rem 1.25rem" }}
            >
              Continue to Sign In
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <h2 style={{ margin: "0 0 1rem", fontSize: "1.3rem" }}>Verification failed</h2>
            <p style={{ opacity: 0.8, fontSize: "0.9rem", lineHeight: 1.5, color: "#ff7f7f" }}>
              {error?.message ?? "This verification link is invalid or has expired."}
            </p>
            <button
              onClick={goToSignIn}
              className="theme-button"
              style={{ marginTop: "1rem", padding: "0.5rem 1.25rem" }}
            >
              Back to Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
}
